import {
  SET_FINGERPRINT,
  SET_FINGERPRINT_SUCCESS,
  SET_FINGERPRINT_ERROR,
  POST_TRACKING_DETAILS,
  POST_TRACKING_DETAILS_SUCCESS,
  POST_TRACKING_DETAILS_ERROR,
} from './affiliateActionConstants';

// set FINGERPRINT
export const setFingerprint = (payload) => ({
  type: SET_FINGERPRINT,
  payload,
});

export const setFingerprintSuccess = (payload) => ({
  type: SET_FINGERPRINT_SUCCESS,
  payload,
});

export const setFingerprintError = (payload) => ({
  type: SET_FINGERPRINT_ERROR,
  payload,
});

// POST tracking details
export const postTrackingDetails = (payload) => ({
  type: POST_TRACKING_DETAILS,
  payload,
});

export const postTrackingDetailsSuccess = (payload) => ({
  type: POST_TRACKING_DETAILS_SUCCESS,
  payload,
});

export const postTrackingDetailsError = (payload) => ({
  type: POST_TRACKING_DETAILS_ERROR,
  payload,
});
